module.exports = __webpack_public_path__ + "static/media/Coverphoto-Sidebar.ed6c68b0.jpg";